import { BasketSummary } from '../interfaces/Basket/BasketSummary';

const allCitiesKey = '__ALL_CITIES__';

export const getTotalBasketAmount = (basketSummary?: BasketSummary): number =>
  basketSummary?.items.reduce((acc, item) => acc + item.total.amount, 0) ?? 0;

export const getTotalBasketQuantity = (basketSummary?: BasketSummary): number =>
  basketSummary?.items.reduce((acc, item) => acc + item.quantity, 0) ?? 0;

export const getFreeShippingAmount = (
  basketSummary?: BasketSummary,
  city?: string,
): number | undefined => {
  if (!basketSummary) {
    return undefined;
  }

  const globalLimit = basketSummary.freeShippingAmountMap[allCitiesKey];
  const specificLimit = city
    ? basketSummary.freeShippingAmountMap[city]
    : undefined;

  if (
    Number.isFinite(globalLimit) &&
    (!Number.isFinite(specificLimit) || globalLimit < specificLimit!)
  ) {
    return globalLimit;
  }

  return specificLimit;
};
